module.exports = __webpack_public_path__ + "static/media/chatter.e1ecef6b.svg";